import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString} from "@pg-mono/request";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {appendOfferListQuery} from "../offer_list_url/build_offer_list_url";
import {IOfferListUrlInput} from "../offer_list_url/offer_list_url_values";

export const getRouteUrlWithQuery = (ctx: Pick<IFetchContext<IRPRequestMeta>, "match" | "route">, query: IOfferListUrlInput): string =>
    ctx.match.params.friendlySlug ? appendOfferListQuery(ctx.route.pathname, query) : appendQueryString(ctx.route.pathname, query);
import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString} from "@pg-mono/request";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {appendOfferListQuery} from "../offer_list_url/build_offer_list_url";
import {IOfferListUrlInput} from "../offer_list_url/offer_list_url_values";

export const getRouteUrlWithQuery = (ctx: Pick<IFetchContext<IRPRequestMeta>, "match" | "route">, query: IOfferListUrlInput): string =>
    ctx.match.params.friendlySlug ? appendOfferListQuery(ctx.route.pathname, query) : appendQueryString(ctx.route.pathname, query);
